/**
 * enum for reusable component id
 */
export enum ReuseComponent {
  CandidatesListComponent = "79c3b0e8-5675-4d03-b335-c5d734d00c11",
  PotentialCandidatesListComponent = "3350099e-8562-4c98-b450-1e7a7d1a21c3",
  GeneralApplicationsDashboardComponent = "65b9e466-8b97-4489-a455-4be7e2ae16a9",
  LastVisitedCandidatesListComponent = "e80a1fd8-3c55-437c-a650-1815408df46e",
  FavoriteCandidatesListComponent = '23f99696-882b-4da7-902f-283416d55e4e',
  RequisitionCandidatesListComponent = "c1f70cef-45ec-468f-90b7-ca280f023735",
  MyHiringRequestsComponent = "f2e84b52-4c4c-4525-984f-209c2b1daf22",
  JobRequisitionsListComponent = "7893f27c-0624-48fd-aac0-7a7995c8ea39",
  DraftJobRequisitionsListComponent = "53bbd201-2769-4a5b-97e5-204ae3c202a6",
  MyJobRequisitionsListComponent = "6da13114-a56f-40ff-ad76-bb0a672a5034",
  ArchivedJobRequisitionsListComponent = "c23e0b68-440c-4194-9f78-bc96167021dd",
  JobDescriptionListComponent = '8e6394af-23f0-438e-82cb-a92206bd6347',
  EmailsListComponent = 'bdf812d7-c354-4936-a03b-3753d0b6f149',
  FailedEmailsListComponent = '64d1682e-b069-4c5a-a29d-804e53059d8b',
  HiringRequestWorkflowsListComponent = '4976fa66-6178-470e-ad74-832ef8d9b3dd',
  ReportsListComponent = '96a0c1c2-d0d5-45cb-a1cb-7174a01209c0',
  AnnouncementsListComponent = 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
  RecruitmentEventsListComponent = 'b2c4d6e8-f0a1-2345-bcde-123456789abc',
  RecruitmentEventApplicationsListComponent = '667f7351-bafe-462c-a937-3be3ca6fca3e',
  UsersListComponent = 'e3ad21cf-8f64-418e-a2df-28188de2fce3',
  EmailTemplatesListComponent = '86a172fb-655f-46d2-9438-d266d54effb7',
  FeedbackTemplatesListingComponent = 'b7eefd62-39a5-4848-b587-a415fe7a801b',
  RecruitmentEventTemplatesListingComponent = 'a31db8c3-714e-435a-8e06-855beb40f024',
  WebsitePopupListComponent = '074aad59-3a37-45f1-af10-ccb7e31c0b97'
}
